import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from 'material-ui/List';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const ComplianceListItem = ({id, name, skillCount}) => {
    const infoLink = `/dashboard/compliances`;
    const secondaryText = [];
    if (skillCount || skillCount === 0) {
        secondaryText.push(<span key="skills">{skillCount} skills</span>);
    }
    return (
        <ListItem
            style={style.listItem}
            primaryText={<Link to={infoLink} className="primaryText">{name}</Link>}
            leftAvatar={<Link to={infoLink}><ComplianceIcon style={style.icon} color={statusColours.primary}/></Link>}
            secondaryText={secondaryText}
        />
    );
};

ComplianceListItem.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
};

export default ComplianceListItem;
